module.exports = __webpack_public_path__ + "img/pro_mega10_07.ca36de90.jpg";